import styled from "styled-components";
import { BASIC_DARK_GRAY, BASIC_LINE } from "../../../constants/colors";
import { Menu } from "../../../ducks/menu";
import { MenuItem } from "./MenuItem";

type Props = {
  category: {
    id: number;
    name: string;
  };
  menus: Menu[];
  selectedLimitedMenus: Menu[];
  onFavorite: (
    menuId: number,
    menuCode: string,
    isFavorite: boolean,
    onSuccess?: () => void,
  ) => void;
  onSelectMenu: (args: {
    menuId: number;
    menuName: string;
    amount: number;
    isEarlyBird: boolean;
    optionId?: number;
    optionName?: string;
  }) => void;
  categoryRef: React.LegacyRef<HTMLDivElement> | undefined;
};

export const MenuListByCategory: React.FC<Props> = ({
  category,
  menus,
  selectedLimitedMenus,
  categoryRef,
  onFavorite,
  onSelectMenu,
}) => {
  return (
    <div>
      <MenuCategory
        ref={categoryRef}
        data-id={category.id}
        data-name={category.name}
      >
        {category.name}
      </MenuCategory>

      {menus.map((menu) => (
        <MenuItem
          key={menu.id + (category.id === -1 ? "_favorite" : "")}
          menu={menu}
          selectedLimitedMenus={selectedLimitedMenus}
          onFavorite={(...args) => onFavorite(menu.id, ...args)}
          onSelectMenu={(args) =>
            onSelectMenu({
              menuId: menu.id,
              menuName: menu.name,
              isEarlyBird: menu.isEarlyBird,
              ...args,
            })
          }
          noPopup={category.id === -1}
        />
      ))}
    </div>
  );
};

const MenuCategory = styled.div`
  margin: 20px 0;
  font-size: 20px;
  font-weight: 500;
  border-bottom: 1px solid ${BASIC_LINE};
  color: ${BASIC_DARK_GRAY};
`;
